import ApiService from './service';
import * as http from './http';

export class WhatsNewSiteAccessService extends ApiService {
    async getWhatsNewSiteAccess(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async addWhatsNewSiteAccess(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.post(url, data, this.store);
    }

    async updateWhatsNewSiteAccess(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.put(url, data, this.store);
    }
}
